import { useMutation, useQuery } from "@tanstack/react-query";
import { CommunityCategoryDto, SearchDto } from "../../../../services/dto";
import { IActionResponse, IActionResult } from "../../../../assets/utils/lib";

import { LookupDto } from "../../../../assets/utils/lib/lookupDto";
import { Constants } from "../../../../assets/utils/lib/constants";
import { CommunityCategoryClient } from "../../../../services/proxies/community/communityCategoryClient";

export namespace CategoryService {
  const categoryClient = new CommunityCategoryClient();

  export const save = () =>
    useMutation<
      IActionResult<CommunityCategoryDto>,
      Error,
      CommunityCategoryDto
    >({
      mutationFn: async (payload: CommunityCategoryDto) => {
        return await categoryClient.saveCommunityCategoryAsync(payload);
      },
    });

  export const getCategoryQuery = (id: string | undefined) =>
    useQuery({
      queryKey: ["categoryQuery", id],
      queryFn: async () => await categoryClient.getCategoryAsync(id),
      enabled: Boolean(id && id !== Constants.emptyGuid),
    });

  export const gridQuery = (searchQuery: SearchDto) =>
    useQuery({
      queryKey: ["categoryGridQuery", searchQuery],
      queryFn: async () =>
        await categoryClient.searchCommunityCategoriesAsync(searchQuery),
    });

  export const getLookups = () =>
    useQuery({
      queryKey: ["categoryLookupsQuery"],
      queryFn: async () => await categoryClient.getLookupsAsync(),
      select: (data) => {
        return {
          communities: LookupDto.mapToOptions(data?.community),
        };
      },
    });

  export const cancelCategory = () =>
    useMutation<IActionResponse, Error, string>({
      mutationFn: async (id: string | undefined) => {
        return await categoryClient.deActivateCommunityCategoryAsync(id);
      },
    });

  export const deleteCategory = () =>
    useMutation<IActionResponse, Error, string>({
      mutationFn: async (id: string | undefined) => {
        return await categoryClient.deleteCategoryAsync(id);
      },
    });
}
